// Modern Google Places autocomplete using @googlemaps/js-api-loader
import { importLibrary } from "../maps/google_maps_loader"

console.log("[DEBUG-JS] places_autocomplete.js loaded")

// Store references to avoid repeated DOM lookups
let autocompleteInstance = null
let googleMapsEvent = null

// Initialize Places Autocomplete
async function initPlacesAutocomplete() {
  console.log("[PLACES] initPlacesAutocomplete called")

  const placeSearchInput = document.getElementById("place_search")
  const searchStatus = document.getElementById("search_status")

  if (!placeSearchInput || !searchStatus) {
    console.log("[PLACES] Required elements not found")
    return
  }

  try {
    // Load the Places library - API key should already be set from module level
    const { Autocomplete } = await importLibrary("places")
    const { event } = await importLibrary("core")
    googleMapsEvent = event

    console.log("[PLACES] Google Maps API loaded successfully")

    // Destroy existing instance if it exists
    if (autocompleteInstance) {
      googleMapsEvent.clearInstanceListeners(placeSearchInput)
      autocompleteInstance = null
    }

    // Create the autocomplete object
    autocompleteInstance = new Autocomplete(placeSearchInput, {
      types: ["establishment"],
      fields: ["place_id", "name", "formatted_address", "geometry"],
    })

    // Update status to show it's working
    searchStatus.textContent = "Start typing to search for bars..."
    searchStatus.classList.remove("text-red-500")

    // Handle place selection
    autocompleteInstance.addListener("place_changed", function () {
      const place = autocompleteInstance.getPlace()

      if (!place.geometry) {
        searchStatus.textContent = "Please select a place from the dropdown"
        searchStatus.classList.add("text-red-500")
        return
      }

      // Show the selected place details
      const placeDetails = document.getElementById("place_details")
      const selectedPlaceName = document.getElementById("selected_place_name")
      const selectedPlaceAddress = document.getElementById("selected_place_address")
      const selectedPlaceIdField = document.getElementById("selected_place_id")
      const selectedPlaceNameField = document.getElementById("selected_place_name_field")
      const selectedPlaceAddressField = document.getElementById("selected_place_address_field")
      const existingBarSelection = document.getElementById("existing_bar_selection")
      const newBarSelection = document.getElementById("new_bar_selection")
      const newBarName = document.getElementById("new_bar_name")
      const stopBarId = document.getElementById("stop_bar_id")
      const manualBarName = document.getElementById("manual_bar_name")
      const manualBarAddress = document.getElementById("manual_bar_address")

      if (placeDetails) placeDetails.classList.remove("hidden")
      if (selectedPlaceName) selectedPlaceName.textContent = place.name
      if (selectedPlaceAddress) selectedPlaceAddress.textContent = place.formatted_address

      // Set hidden fields
      if (selectedPlaceIdField) selectedPlaceIdField.value = place.place_id || ""
      if (selectedPlaceNameField) selectedPlaceNameField.value = place.name || ""
      if (selectedPlaceAddressField) selectedPlaceAddressField.value = place.formatted_address || ""

      // Update the display for new bar
      if (existingBarSelection) existingBarSelection.classList.add("hidden")
      if (newBarSelection) newBarSelection.classList.remove("hidden")
      if (newBarName) newBarName.textContent = place.name

      // Clear the bar_id field to indicate we need to create a new bar
      if (stopBarId) stopBarId.value = ""

      // Clear the manual fields to avoid confusion
      if (manualBarName) manualBarName.value = ""
      if (manualBarAddress) manualBarAddress.value = ""

      searchStatus.textContent = "Selected: " + place.name
      searchStatus.classList.remove("text-red-500")

      console.log("[PLACES] Place selected:", place.name)
    })

    console.log("[PLACES] Autocomplete initialized successfully")
  } catch (e) {
    console.error("[PLACES] Error initializing Places API:", e)
    searchStatus.textContent = "Google Places search failed. Use manual entry below."
    searchStatus.classList.add("text-red-500")
  }
}

// Initialize when page loads or changes
async function setupPlacesAutocomplete() {
  console.log("[PLACES] Setting up Places autocomplete")

  // Look for the search input to see if we're on the right page
  const searchInput = document.getElementById("place_search")
  if (searchInput) {
    console.log("[PLACES] Search input found, initializing autocomplete")
    await initPlacesAutocomplete()
  } else {
    console.log("[PLACES] Not on the stop form page, skipping Places API initialization")
  }
}

// Register event handlers for Turbo
document.addEventListener("turbo:load", function () {
  console.log("[PLACES] turbo:load event fired")
  setupPlacesAutocomplete()
})

document.addEventListener("turbo:render", function () {
  console.log("[PLACES] turbo:render event fired")
  setupPlacesAutocomplete()
})

// Also handle regular page load
document.addEventListener("DOMContentLoaded", function () {
  console.log("[PLACES] DOMContentLoaded event fired")
  setupPlacesAutocomplete()
})

export default { setupPlacesAutocomplete }
